import React from 'react'
import { Box, Paper } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { MainPageBox } from '../../components/DisplayHelpers/MainPageBox'
import { QualifyingDeviceComponent } from './QualifyingDevice.component'
import { APP_PATHS } from '../../components/AppRouter/types'
import { IosHomePartialIcon } from '../../components/Icons/IosHomePartialIcon'
import { AppleWatchPartialIcon } from '../../components/Icons/AppleWatchPartialIcon'
import {
  sendTrackingEvent,
  toButtonEvent,
  toScreenEvent
} from '../../services/amplitude.service'
import { ButtonProcessedEvent, ScreenOpendedEvent } from './types'

const QualifyingDevice: React.FC = () => {
  const navigate = useNavigate()

  sendTrackingEvent(toScreenEvent(ScreenOpendedEvent))

  const handleNext = () => {
    sendTrackingEvent(toButtonEvent(ButtonProcessedEvent))
    navigate(APP_PATHS.SIGN_UP)
  }

  return (
    <MainPageBox>
      <Paper
        elevation={2}
        sx={{
          maxWidth: 600,
          minWidth: 300,
          pb: 2.5
        }}
      >
        <Box sx={{ p: 5 }}>
          <QualifyingDeviceComponent handleClick={handleNext} />

          <Box sx={{ textAlign: 'center', mt: 3, position: 'relative' }}>
            <IosHomePartialIcon
              sx={{ height: '11rem', width: '10rem', zIndex: 1 }}
            />
            <AppleWatchPartialIcon
              sx={{ height: '4rem', width: '4rem', zIndex: 2, ml: -7 }}
            />
          </Box>
        </Box>
      </Paper>
    </MainPageBox>
  )
}

export default QualifyingDevice
